export default {
  namespaced: true,
  state: {
    message: '',
    color: ''
  },
  getters: {
    message: state => state.message,
    color: state => state.color
  },
  actions: {
    info ({commit}, message) {
      commit('SET_MESSAGE', {'message': message, 'color': 'info'})
    },
    error ({commit}, message) {
      commit('SET_MESSAGE', {'message': message, 'color': 'error'})
    },
    warning ({commit}, message) {
      commit('SET_MESSAGE', {'message': message, 'color': 'warning'})
    },
    success ({commit}, message) {
      commit('SET_MESSAGE', {'message': message, 'color': 'success'})
    },
    reset ({commit}) {
      commit('SET_BLANK')
    }
  },
  mutations: {
    'SET_MESSAGE': (state, payload) => {
      state.message = payload.message
      state.color = payload.color
    },
    'SET_BLANK': (state) => {
      state.message = ''
      state.color = ''
    }
  }
}